module.exports = __webpack_public_path__ + "static/media/UC-ce4d5c18-541e-46a2-b0e1-cec73888d553.8c84a82a.jpg";